export default {
  sections: {
    asap_orders: {
      title: 'Comenzi imediate',
      fields: {
        has_live_orders: {
          label: 'Comenzi live',
          tooltip: 'Activați doar când restaurantul este gata să intre live și să accepte comenzi',
        },
        has_asap_orders: {
          label: 'Permiteți clienților să plaseze comenzi imediate?',
          tooltip: '*Comenzile imediate se bazează pe timpul de preparare',
        },
      },
    },
    scheduled_orders: {
      title: 'Comenzi programate',
      fields: {
        has_scheduled_orders: {
          label: 'Permiteți clienților să comande în avans pentru ore specifice?',
        },
        has_pre_order: {
          label: 'Permiteți clienților să comande cu mai mult de o zi în avans?',
        },
        max_pre_order_days: {
          label: 'Număr maxim de zile de comandă în avans',
          placeholder: '14',
        },
        has_scheduled_order_reminders: {
          label: 'Notificări de reamintire comenzi programate',
        },
        scheduled_orders_time_slot_interval: {
          label: 'Intervale de timp în minute',
          option: 'Interval de {{value}} minute',
        },
        has_scheduled_orders_time_slot_order_limit: {
          label: 'Adăugați cantitate maximă de comenzi per interval',
        },
        scheduled_orders_time_slot_order_limit: {
          label: 'Cantitate maximă de comenzi per interval',
          placeholder: '5',
        },
        order_instructions_title: {
          label: 'Instrucțiuni comandă',
          placeholder: 'Introduceți instrucțiuni pentru comandă',
        },
        scheduled_order_option_title: {
          label: 'Titlu opțiune programare ulterioară',
          placeholder: 'Programează pentru mai târziu',
        },
      },
    },
    other: {
      title: 'Altele',
      fields: {
        order_approval_time_step: {
          label: 'Adăugare / reducere timp comandă confirmată',
          option: '{{value}} min',
        },
        order_confirmation_time_extra_minutes: {
          label: 'Adăugare minute suplimentare la timpul confirmat',
          option: '{{value}} min',
        },
      },
    },
  },
  buttons: {
    save: 'Salvează',
  },
  feedback: {
    restaurant_suspended: {
      title: 'Acest restaurant a fost suspendat',
      description:
        'Pentru a reveni live, navigați la <a>pagina de abonament</a> și reactivați restaurantul, după care veți putea activa comenzile live pe această pagină.',
    },
  },
  toasts: {
    at_least_one_order_method_required:
      'Cel puțin 1 metodă de comandă (programată sau imediată) trebuie să fie activată. Nu le puteți dezactiva pe ambele.',
  },
};
